// Package Imports
import axios from "axios";
import moment from "moment";
import { toJS } from "mobx";

// Project Imports
import NeedTypeEnum from "../../../../constants/NeedTypeEnum";
import OptimizationStore from "../../store/OptimizationStore";
import * as APITypes from "constants/API";
import updateChangeLAFamilyProductId from "./updateChangeLAFamilyProductId";
import StorageKeys from "../../../../constants/StorageKeys";
import generateChangeLADataStructure from "./generateChangeLADataStructure";
import generateChangesSecondaryLAStructure from "./generateChangesSecondaryLAStructure";

const generateChangeLAFamilyProductId = async (data, hideModal, needType) => {
  // API Request Updation 
  const changedLADetails = OptimizationStore.changeLaDetails.eligibleList.find(
    (item) => item.id === OptimizationStore.selectedFamilyMemberId
  );

  data.family_member_id = OptimizationStore.selectedFamilyMemberId;

  let productId = "";
  if (Array.isArray(OptimizationStore.selectedNeedCardData.BI)) {
    let riskProductData = OptimizationStore.selectedNeedCardData.BI.filter(
      (item) => item.risk == OptimizationStore.selectedNeedCardData.selectedRisk
    )[0];
    productId = riskProductData.family_product_id;
  } else {
    productId = OptimizationStore.selectedNeedCardData.family_product_id;
  }

  data.family_product_id = productId;

  // Function call
  if (data.secondary_la_id != "" && data.secondary_la_id != undefined) {
    generateChangesSecondaryLAStructure(data, needType)
  } else {   
    generateChangeLADataStructure(data, needType);
  }
  if (hideModal !== undefined) hideModal();

  // API Request Updation
  data.dob = moment(changedLADetails.dob).format("YYYY-MM-DD");
  data.monthly_income = changedLADetails.monthly_income;

  const familyMemberDetailObj = toJS(OptimizationStore.familyMemberDetailObj);
  if (
    Object.values(familyMemberDetailObj).indexOf(
      OptimizationStore?.selectedFamilyMemberId?.toString()
    ) > -1 &&
    needType === NeedTypeEnum.PROTECTION_FOR_MY_FAMILY
  ) {
    data.dob = moment(familyMemberDetailObj.dob).format("YYYY-MM-DD");
    data.monthly_income = familyMemberDetailObj.monthlyIncome;
  }
  // API Call
  const apiResponse = await axios.post(
    APITypes.CHANGE_LA_FAMILY_PRODUCT_ID,
    data
  );
  if (apiResponse.data.status !== "error") {
    localStorage.setItem(
      StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM,
      false
    );
    updateChangeLAFamilyProductId(apiResponse.data, data, needType);
  }
};

export default generateChangeLAFamilyProductId;
